<template>
    <div></div>
</template>

<script>
	export default {
		name: "RootAdminView"
	}
</script>

<style scoped>

</style>
